<template>
  <div class="adCode-tab" :class="{ 'px-8': !breakpointXs, 'px-2': breakpointXs }">
    <v-dialog v-model="dialog" max-width="750" persistent>
      <v-card :class="{ 'pa-7': !breakpointXs, 'pa-2': breakpointXs }">
        <v-card-title class="justify-space-between pa-0">
          <div :class="{ 'fs-25': !breakpointXs, 'fs-20': breakpointXs, 'fw-600': true }">
            Add AD Code for <b class="pl-2">{{ exporter.name }}</b>
          </div>
          <v-btn v-if="!breakpointXs" icon @click="adCodedialogHandler">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
          <ValidationObserver @keydown.tab="focusNext" v-slot="{ passes }" class="w-100">
            <v-row class="pt-6">
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="adCode"
                  required
                  rules="required"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isAdCodeTabFormLoading"
                  label="Ad Code"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="bankName"
                  required
                  rules="required"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isAdCodeTabFormLoading"
                  label="Bank Name"
                />
              </v-col>
            </v-row>
            <div class="d-block d-sm-flex justify-center">
              <v-btn
                width="140"
                color="button-primary"
                large
                :block="breakpointXs"
                :class="{ 'white--text': true, 'my-3': !breakpointXs, 'ml-0 mt-3': breakpointXs }"
                :loading="isAdCodeTabFormLoading"
                @click="passes(addAdCode(exporter))"
              >
                <span class="font-weight-bold fs-15">Add New</span>
              </v-btn>
            </div>
          </ValidationObserver>
        </v-card-title>
        <div class="adCode-tab__table pt-2">
          <div
            class="adCode-tab__table__header d-sm-flex justify-space-between align-center"
            :class="{ 'text-center': breakpointXs }"
          ></div>
          <v-divider class="my-10"></v-divider>
          <div class="adCode-tab__table__body mt-5">
            <v-data-table :items-per-page="5" :headers="tableHeaders" :items="exporter.ad_codes">
              <!-- Delete AD Code button -->
              <template v-slot:item.deleteAction="{ item }">
                <v-btn color="lightPrimary" class="error font-weight-bold" dense @click="deleteActionHandler(item)"
                  >Delete</v-btn
                >
              </template>
              <!-- Delete AD Code button over -->
            </v-data-table>
            <ConfirmDeleteDialog
              v-if="showDeleteConfirmationDialog"
              :loader="isDeletingAdcode"
              @clicked-yes="deleteAdCode(storeAdcode)"
              @clicked-no="showDeleteConfirmationDialog = false"
            />
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import TextField from "@/components/TextField";
import * as AT from "../store/actionTypes";
import ConfirmDeleteDialog from "@/modules/DashboardModule/components/ConfirmDeleteDialog";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "AdCodeModal",
  components: {
    ValidationObserver,
    TextField,
    ConfirmDeleteDialog
  },
  data() {
    return {
      adCode: "",
      bankName: "",
      showDeleteConfirmationDialog: false,
      isAdCodeTabFormLoading: false,
      dialog: true,
      storeAdcode: "",
      isDeletingAdcode: false,
      items: []
    };
  },
  props: {
    exporter: {
      type: Object,
      default: () => {
        return {
          id: 0,
          name: "",
          iec: "",
          address1: "",
          address2: "",
          branch: "",
          city: "",
          state: "",
          pin: "",
          ad_codes: [],
          bankName: "",
          adCode: ""
        };
      }
    }
  },
  mounted() {
    this.mapSrNoToAdCode();
  },
  mixins: [commonMethodsMixin],
  methods: {
    addAdCode(exporter) {
      this.isAdCodeTabFormLoading = true;
      const formData = {
        bank_name: this.bankName,
        ad_code: this.adCode,
        exporterId: exporter.id
      };
      this.$store
        .dispatch(AT.ADD_AD_CODE, formData)
        .then(res => {
          if (res && res.data) {
            const adCodeIndex = this.exporter.ad_codes.findIndex(adCode => {
              return adCode.id === res.data.id;
            });
            if (adCodeIndex >= 0) {
              this.exporter.ad_codes.splice(adCodeIndex, 1);
            }
            this.exporter.ad_codes.push(res.data);
            this.adCode = "";
            this.bankName = "";
          }
          this.mapSrNoToAdCode();
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.isAdCodeTabFormLoading = false;
        });
    },
    deleteAdCode(exporter) {
      this.isAdCodeTabFormLoading = true;
      this.isDeletingAdcode = true;
      this.$store
        .dispatch(AT.DELETE_AD_CODE, exporter.id)
        .then(() => {
          this.exporter.ad_codes.splice(
            this.exporter.ad_codes.findIndex(adCode => adCode.id === exporter.id),
            1
          );
          this.mapSrNoToAdCode();
        })
        .catch(err => {
          this.handleError(err);
          return;
        })
        .finally(() => {
          this.storeAdcode = null;
          this.isDeletingAdcode = false;
          this.showDeleteConfirmationDialog = false;
          this.isAdCodeTabFormLoading = false;
        });
    },
    mapSrNoToAdCode() {
      this.exporter.ad_codes.map((adcode, index) => {
        adcode.srNo = index + 1;
      });
    },
    deleteActionHandler(item) {
      this.showDeleteConfirmationDialog = true;
      this.storeAdcode = item;
    },
    adCodedialogHandler() {
      this.$emit("close-adcode-dialog", true);
    }
  },

  computed: {
    tableHeaders() {
      return [
        { text: "Sr", value: "srNo", align: "center" },
        { text: "Ad Code", value: "ad_code", align: "center" },
        { text: "Bank Name", value: "bank_name", align: "center" },
        { text: "Action", value: "deleteAction", align: "center" }
      ];
    }
  }
};
</script>
<style lang="scss">
.adCode-tab {
  min-height: 350px;
  &__table {
    .v-data-table {
      background: transparent !important;
    }
  }
}
</style>
